module.exports = __webpack_public_path__ + "static/merchant_skies-ca6763fc1ea9554743cde3ca800c8617.png";